var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManchette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "manchette",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1280.17 773.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#e5b595;}.cls-4{fill:#44455a;}.cls-5{fill:#3a3b4f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-418.83 -738.36)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M736,1029s-16,13-90-10-74-31-87-34-73.86-9.34-93-17c-20-8-15-29,9-29,31,4,84,10,87,8s4-9,0-11-136-44-140-50c-7-8-3-33,18-29s121,38,129,35,4-8,2-11-137-61-141-67-1-26,17-22,135,51,141,51,12-3,10-8-108-74-108-74c-8-11,6-28,18-21,0,0,103,50,113,56s32,14,37,19,38,23,67,17c-5-14-18-28-19-46s10-26,14-24,15,24,20,28,12,11,14,15,18,8,24,18,41,71,41,78a8.22,8.22,0,0,1,9,0s127,74,172,91,223,64,288,105,55,46,70,51,103-6,136,0,157,37,162,42c5,17,16,198,10,236,2,40,2,86,2,86l-45-18s-2,4-36-12-95.21-53.07-140-69c-45-16-31-7-146-46-38-12-37-26-127-54s-262-165-295-188S736,1029,736,1029Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "manchette") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M736,1029s-16,13-90-10-74-31-87-34-73.86-9.34-93-17c-20-8-15-29,9-29,31,4,84,10,87,8s4-9,0-11-136-44-140-50c-7-8-3-33,18-29s121,38,129,35,4-8,2-11-137-61-141-67-1-26,17-22,135,51,141,51,12-3,10-8-108-74-108-74c-8-11,6-28,18-21,0,0,103,50,113,56s32,14,37,19,38,23,67,17c-5-14-18-28-19-46s10-26,14-24,15,24,20,28,12,11,14,15,18,8,24,18,41,71,41,78a8.22,8.22,0,0,1,9,0s127,74,172,91,223,64,288,105,55,46,70,51,103-6,136,0,157,37,162,42c5,17,16,198,10,236,2,40,2,86,2,86l-45-18s-2,4-36-12-95.21-53.07-140-69c-45-16-31-7-146-46-38-12-37-26-127-54s-262-165-295-188S736,1029,736,1029Z",
    transform: "translate(-418.83 -738.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M740.88,1032.24S739.06,1005.88,763,958s28-49,56-57,130,55,130,55l750,227-31.63,226.15S1665,1479,1623,1494s-734-297-734-297Z",
    transform: "translate(-418.83 -738.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1686,1327s-136-66-248-84-97-83-227-118S798.78,993.28,758.39,967.64c0,0-12,23.75-14.71,42.06S739,1048,739,1048l382,319,431.11,109.54,62,17.63s15.16,8.16,36-23.51,17.87-80.44,17.87-80.44Z",
    transform: "translate(-418.83 -738.36)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManchette);
export default __webpack_public_path__ + "static/media/manchette.d106296a8374b103d19eda86e3fdb1ac.svg";
export { ForwardRef as ReactComponent };